// extracted by mini-css-extract-plugin
module.exports = {"team":"_e93cbd6","name":"_998b6ad","icon":"_fa940ae","inPlay":"_1b37526","hide":"_4c1d1ca"};